import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { isEmpty } from "lodash";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import AuthContext from "../context/AuthContext";
import PhoneInput from "react-phone-input-2";
import { useContextSelector } from "use-context-selector";
import iconBkash from "../assets/images/bkash.png";
import iconRocket from "../assets/images/rocket.png";
import iconNagad from "../assets/images/nagad.png";
import iconEth from "../assets/images/eth.svg";
import iconBtc from "../assets/images/btc.svg";
import iconUpay from "../assets/images/upay.png";
import bankImg from "../assets/images/bank.png";
import Layout from "./Layout";
import { toFixedWithoutRounding } from "../Utils/constants";

const bankIcon = (name = "") => {
  const n = name.toLowerCase();
  if (n.includes("bkash")) return iconBkash;
  if (n.includes("nagad")) return iconNagad;
  if (n.includes("rocket")) return iconRocket;
  if (n.includes("eth")) return iconEth;
  if (n.includes("btc")) return iconBtc;
  if (n.includes("upay")) return iconUpay;
  return bankImg;
};

const Withdraw = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const getProfileData = useContextSelector(
    AuthContext,
    (ctx) => ctx.getProfileData,
  );
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);
  const amounutRefresh = useContextSelector(
    AuthContext,
    (ctx) => ctx.amounutRefresh,
  );

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: { bankAccount: profileData?.phone },
    mode: "onChange",
    shouldFocusError: true,
  });

  const inputRef = useRef(null);
  const [selectedMethod, setSelectedMethod] = useState("bkash");
  const [id, setId] = useState("");
  const [bank, setBank] = useState([]);
  const [confirmPin, setConfirmPin] = useState(false);
  const [minWithdraw, setMinWithdraw] = useState(500);
  const [maxWithdraw, setMaxWithdraw] = useState(30000);
  const [afterData, setAfterData] = useState({});
  const [verifyEdit, setVerifyEdit] = useState({});
  const [isLoader, setLoader] = useState(false);
  const [isLoader1, setLoader1] = useState(false);

  const {
    register: register1,
    handleSubmit: handleSubmit1,
    control: control1,
    formState: { errors: errors1 },
    reset: reset1,
  } = useForm({});

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    reset: reset2,
  } = useForm({});

  const handleCloseVerify = () => setVerifyEdit({ status: false });

  const onSubmit = async (body) => {
    if (!isEmpty(id)) {
      setConfirmPin(true);
      setAfterData(body);
    } else {
      toast.error(t("PleaseSelectBank"));
    }
  };

  // Same withdrawal payload shape as the old Withdraw.jsx: AccountName is
  // the selected payment method (e.g. "BKASH"), and payout:true is required
  // by the API — both were missing from this file before.
  const AfterPinSubmit = async (body) => {
    setLoader(true);
    const bodyObj = {
      amount: afterData?.amount,
      bank: id,
      AccountName: afterData?.accountName,
      BankAccount: afterData?.bankAccount,
      phone_number: afterData?.phone,
      pin: body?.verificationCode,
      payout: true,
    };
    const { status, data } = await apiPost(apiPath.withdrawal, bodyObj);
    if (status === 200 && data?.success) {
      toast.success(data?.message);
      amounutRefresh();
    } else {
      toast.error(data?.message);
    }
    reset();
    reset2();
    setAfterData({});
    setLoader(false);
    setConfirmPin(false);
  };

  const getBank = async () => {
    const { status, data } = await apiPost(apiPath.getBank, {
      type: "withdrawal",
    });
    if (status === 200 && data?.success) {
      const list = data?.results?.bankList?.map((res) => ({
        ...res,
        bank_name: res?.bank_name?.toLowerCase(),
      }));
      setBank(list || []);
      if (list?.length > 0) getBankDetail(list[0]?._id);
    }
  };

  const getBankDetail = async (body) => {
    setId(body);
    const { status, data } = await apiPost(apiPath.getBankDetail, {
      bank: body,
    });
    if (status === 200 && data?.success) {
      setValue("accountName", data?.results?.bankDetail?.account_name);
      setValue("bankAccount", data?.results?.bankDetail?.account_number);
    }
  };

  const onSubmit1 = async (body) => {
    setLoader1(true);
    const countryCode = inputRef?.current?.state.selectedCountry?.countryCode;
    const trimmedMobile = body?.mobile?.substring(
      countryCode?.length,
      body?.mobile?.toString()?.length,
    );
    // Same endpoint as the old file (apiPath.verifyOtpNew) — this file was
    // pointed at apiPath.verifyOtp, which doesn't match.
    const { status, data } = await apiPost(apiPath.verifyOtpNew, {
      new_phone_number: countryCode + trimmedMobile,
      phone_number: profileData?.phone
        ? profileData?.phone
        : countryCode + trimmedMobile,
      type: "password",
      password: body?.verificationCode,
    });
    setLoader1(false);
    if (status === 200 && data.success) {
      handleCloseVerify();
      getProfileData();
      toast.success(t("OtpVerified"));
      reset();
    } else {
      toast.error(data?.message);
    }
  };

  useEffect(() => {
    getBank();
    getProfileData();
  }, []);

  useEffect(() => {
    if (!isEmpty(profileData) && profileData?.limitSetting?.length > 0) {
      setMinWithdraw(profileData.limitSetting[0]?.minWithdraw);
      setMaxWithdraw(profileData.limitSetting[0]?.maxWithdraw);
    }
  }, [!isEmpty(profileData?.limitSetting)]);

  const withdrawableAmount =
    parseFloat(userCoins?.balance || 0).toFixed(2) -
      parseFloat(profileData?.availableTurnoverFinal || 0).toFixed(2) >
    0
      ? toFixedWithoutRounding(
          parseFloat(userCoins?.balance || 0).toFixed(2) -
            parseFloat(profileData?.availableTurnoverFinal || 0).toFixed(2),
        )
      : 0;

  return (
    <Layout>
      <div>
        <div className="funds-tab">
          <div className="v-tabs v-tabs--centered v-tabs--fixed-tabs v-tabs--icons-and-text theme--dark">
            <div
              role="tablist"
              className="v-item-group theme--dark v-slide-group v-tabs-bar v-tabs-bar--is-mobile white--text"
              style={{ height: "auto" }}
            >
              <div className="v-slide-group__wrapper">
                <div className="v-slide-group__content v-tabs-bar__content">
                  <Link
                    to="/deposit"
                    aria-selected={false}
                    role="tab"
                    className="v-tab"
                  >
                    {t("Deposit")}
                  </Link>
                  <a
                    tabIndex={0}
                    href="#withdrawal"
                    aria-selected={true}
                    role="tab"
                    className="v-tab v-tab--active"
                  >
                    {t("Withdrawal")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="v-window v-item-group theme--light v-tabs-items">
          <div className="v-window__container">
            <div
              className="v-window-item v-window-item--active"
              id="withdrawal"
            >
              <div className="funds-container">
                <div className="funds-wrapper v-card v-sheet theme--light elevation-0">
                  <div className="row withdrawal-wallet no-gutters">
                    <div className="wallet-label col col-12">
                      <label className="white--text">{t("MainWallet")}</label>
                      <div className="refresh-balance-icon" />
                    </div>
                    <div className="balance col">
                      <div className="text-capitalize">
                        <span className="white--text">
                          ৳ {parseFloat(userCoins?.balance || 0).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </div>

                  {!profileData?.phone && (
                    <div className="row section-container no-gutters">
                      <div className="d-flex align-center">
                        <div
                          className="v-image v-responsive theme--light"
                          style={{ height: "25px", width: "25px" }}
                        >
                          <div
                            className="v-responsive__sizer"
                            style={{ paddingBottom: "100%" }}
                          />
                          <div
                            className="v-image__image v-image__image--contain"
                            style={{
                              backgroundImage:
                                'url("/static/svg/personal-info-warning.svg")',
                              backgroundPosition: "center center",
                            }}
                          />
                        </div>
                        <label className="px-2">
                          {t("PhoneNotVerified")}
                        </label>
                        <label
                          className="link-underscore warning-text"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setVerifyEdit({
                              status: true,
                              phoneStatus: "add",
                              item: profileData?.phone,
                            })
                          }
                        >
                          {t("Verify")}
                        </label>
                      </div>
                    </div>
                  )}

                  <form
                    noValidate
                    className="v-form"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <input type="hidden" {...register("accountName")} />
                    <input type="hidden" {...register("bankAccount")} />

                    <div className="section-container no-gutters col">
                      <div className="funds-title-wrapper">
                        <label className="text-capitalize subtitle-1 funds-title">
                          {t("PaymentMethods")}
                        </label>
                      </div>
                      <div className="funds-divider" />
                      {bank.length === 0 && (
                        <div className="col col-auto">
                          <span style={{ color: "black" }}>
                            {t("NoPaymentMethods")}
                          </span>
                        </div>
                      )}
                      <div className="row button-container no-gutters">
                        {bank.map((method) => (
                          <div className="col col-auto" key={method._id}>
                            <button
                              type="button"
                              value={method.bank_name}
                              onClick={() => {
                                setSelectedMethod(method.bank_name);
                                getBankDetail(method._id);
                              }}
                              className={`pa-2 gateway-button v-btn v-btn--outlined theme--light v-size--default${
                                selectedMethod === method.bank_name
                                  ? " active-gateway-button v-btn--active"
                                  : ""
                              }`}
                              style={{ height: "100%" }}
                            >
                              <span className="v-btn__content">
                                <img
                                  src={bankIcon(method.bank_name)}
                                  className="paymentChannelIcon"
                                />
                                <label>{method.bank_name.toUpperCase()}</label>
                              </span>
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="section-container no-gutters col">
                      <div className="funds-title-wrapper">
                        <label className="text-capitalize subtitle-1 funds-title">
                          {t("Amount")}
                        </label>
                      </div>
                      <div className="funds-divider" />
                      <div className="v-input funds-input theme--light v-text-field v-text-field--prefix v-text-field--is-booted v-text-field--placeholder">
                        <div className="v-input__control">
                          <div className="v-input__slot">
                            <div className="v-text-field__slot">
                              <div className="v-text-field__prefix">৳</div>
                              <input
                                type="number"
                                placeholder={t("WithdrawMinMaxPlaceholder", { min: minWithdraw, max: maxWithdraw })}
                                {...register("amount", {
                                  required: {
                                    value: true,
                                    message: t("PleaseEnterAmount"),
                                  },
                                  validate: (value) => {
                                    if (value > 0) {
                                      if (Number(value) > Number(maxWithdraw)) {
                                        return t("AmountShouldNotExceed", { max: maxWithdraw });
                                      } else if (value < Number(minWithdraw)) {
                                        return t("MinAmountShouldBe", { min: minWithdraw });
                                      }
                                    } else {
                                      return t("PleaseEnterAmount");
                                    }
                                  },
                                })}
                              />
                            </div>
                          </div>
                          <div className="v-text-field__details">
                            <div className="v-messages theme--light">
                              <div className="v-messages__wrapper">
                                {errors.amount && (
                                  <span className="error-message">
                                    {errors.amount.message}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row section-container no-gutters">
                      <div className="funds-title-wrapper">
                        <label className="text-capitalize subtitle-1 funds-title">
                          {t("PhoneNumber")}
                        </label>
                      </div>
                      <div className="funds-divider" />
                      <div className="col-md-5 col-lg-4 col">
                        <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty v-input--is-disabled v-input--is-readonly theme--light v-text-field v-text-field--prefix v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                          <div className="v-input__control">
                            <div className="v-input__slot">
                              <div className="v-text-field__slot">
                                <div className="v-text-field__prefix">+880</div>
                                <input
                                  disabled
                                  readOnly
                                  type="text"
                                  defaultValue={profileData?.phone}
                                  {...register("phone")}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row pa-3 no-gutters">
                      <button
                        type="submit"
                        disabled={isLoader}
                        className="pa-2 funds-button white--text v-btn v-btn--has-bg  v-size--default buttonPrimary theme-button subtitle-1"
                      >
                        <span className="v-btn__content">{t("Withdraw")}</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {verifyEdit?.status && (
        <div
          role="document"
          tabIndex={0}
          className="v-dialog__content v-dialog__content--active"
          style={{ zIndex: 202 }}
        >
          <div
            className="v-dialog v-dialog--active v-dialog--persistent"
            style={{ maxWidth: "400px" }}
          >
            <div className="dialog-card v-card v-sheet theme--light">
              <div className="row no-gutters justify-space-between dialog-header">
                <div className="d-flex flex-column pl-6 py-4 col col-10">
                  <label className="dialog-title text-capitalize d-block full-width white--text">
                    Verify Phone Number
                  </label>
                </div>
                <div className="d-flex justify-content-center align-content-center col col-2">
                  <button
                    type="button"
                    onClick={handleCloseVerify}
                    aria-label="Close"
                    className="v-icon notranslate full-width v-icon--link mdi mdi-close theme--light white--text dialog-close-icon"
                  />
                </div>
              </div>

              <div className="row dialog-row no-gutters">
                <form
                  noValidate
                  className="v-form"
                  onSubmit={handleSubmit1(onSubmit1)}
                >
                  <div className="mobile">
                    <div className="row no-gutters justify-space-between">
                      <div className="col col-10">
                        <label
                          className="input-field-label ma-0 text-capitalize d-block"
                          style={{ float: "left" }}
                        >
                          New Phone Number
                          <span className="red--text ml-1">*</span>
                        </label>
                      </div>
                      <div className="col col-2" />
                      <div className="col col-12">
                        <div
                          className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined ${
                            errors1.mobile
                              ? "v-input--has-state error--text"
                              : ""
                          }`}
                        >
                          <div className="v-input__control">
                            <div className="v-input__slot">
                              <fieldset aria-hidden="true">
                                <legend style={{ width: "0px" }}>
                                  <span className="notranslate">​</span>
                                </legend>
                              </fieldset>
                              <div className="v-text-field__slot">
                                {verifyEdit?.phoneStatus === "add" && (
                                  <Controller
                                    control={control1}
                                    name="mobile"
                                    rules={{
                                      required: "Please enter mobile number",
                                      validate: (value) => {
                                        const cc =
                                          inputRef?.current?.state
                                            ?.selectedCountry?.countryCode;
                                        const inputValue = value
                                          ?.toString()
                                          ?.slice(cc?.length, value?.length);
                                        if (inputValue?.length < 10)
                                          return "Minimum 10 digits required";
                                        if (inputValue?.length > 12)
                                          return "Maximum 12 digits allowed";
                                        return true;
                                      },
                                    }}
                                    render={({ field: { ref, ...field } }) => (
                                      <PhoneInput
                                        {...field}
                                        inputExtraProps={{
                                          ref,
                                          required: true,
                                          autoFocus: true,
                                        }}
                                        ref={inputRef}
                                        className="inputrefNew"
                                        country={"bd"}
                                      />
                                    )}
                                  />
                                )}
                              </div>
                            </div>
                            {errors1.mobile?.message && (
                              <div className="v-text-field__details">
                                <div
                                  className="v-messages theme--light error--text"
                                  role="alert"
                                >
                                  <div className="v-messages__wrapper">
                                    <div className="v-messages__message">
                                      {errors1.mobile.message}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mobile">
                    <div className="row no-gutters justify-space-between">
                      <div className="col col-10">
                        <label
                          className="input-field-label ma-0 text-capitalize d-block"
                          style={{ float: "left" }}
                        >
                          Password
                          <span className="red--text ml-1">*</span>
                        </label>
                      </div>
                      <div className="col col-2" />
                      <div className="col col-12">
                        <div
                          className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined ${
                            errors1.verificationCode
                              ? "v-input--has-state error--text"
                              : ""
                          }`}
                        >
                          <div className="v-input__control">
                            <div className="v-input__slot">
                              <fieldset aria-hidden="true">
                                <legend style={{ width: "0px" }}>
                                  <span className="notranslate">​</span>
                                </legend>
                              </fieldset>
                              <div className="v-text-field__slot">
                                <input
                                  type="text"
                                  placeholder="Enter password"
                                  {...register1("verificationCode", {
                                    required: "Please enter password",
                                  })}
                                />
                              </div>
                            </div>
                            {errors1.verificationCode?.message && (
                              <div className="v-text-field__details">
                                <div
                                  className="v-messages theme--light error--text"
                                  role="alert"
                                >
                                  <div className="v-messages__wrapper">
                                    <div className="v-messages__message">
                                      {errors1.verificationCode.message}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row d-flex justify-center align-center no-gutters pt-4">
                    <button
                      type="submit"
                      disabled={isLoader1}
                      className={`pa-2 otpSubmitButton v-btn ${
                        isLoader1 ? "v-btn--disabled" : ""
                      } v-btn--has-bg  v-size--default buttonPrimary theme-button  subtitle-1`}
                    >
                      <span className="v-btn__content">Submit</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {confirmPin && !isEmpty(afterData) && (
        <div
          role="document"
          tabIndex={0}
          className="v-dialog__content v-dialog__content--active"
          style={{ zIndex: 202 }}
        >
          <div
            className="v-dialog v-dialog--active v-dialog--persistent"
            style={{ maxWidth: "400px" }}
          >
            <div className="dialog-card v-card v-sheet theme--light">
              <div className="row no-gutters justify-space-between dialog-header">
                <div className="d-flex flex-column pl-6 py-4 col col-10">
                  <label className="dialog-title text-capitalize d-block full-width white--text">
                    PIN
                  </label>
                </div>
                <div className="d-flex justify-content-center align-content-center col col-2">
                  <button
                    type="button"
                    onClick={() => setConfirmPin(false)}
                    aria-label="Close"
                    className="v-icon notranslate full-width v-icon--link mdi mdi-close theme--light white--text dialog-close-icon"
                  />
                </div>
              </div>

              <div className="row dialog-row no-gutters">
                <form
                  noValidate
                  className="v-form"
                  onSubmit={handleSubmit2(AfterPinSubmit)}
                >
                  <div className="mobile">
                    <div className="row no-gutters justify-space-between">
                      <div className="col col-10">
                        <label
                          className="input-field-label ma-0 text-capitalize d-block"
                          style={{ float: "left" }}
                        >
                          PIN
                          <span className="red--text ml-1">*</span>
                        </label>
                      </div>
                      <div className="col col-2" />
                      <div className="col col-12">
                        <div
                          className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined ${
                            errors2.verificationCode
                              ? "v-input--has-state error--text"
                              : ""
                          }`}
                        >
                          <div className="v-input__control">
                            <div className="v-input__slot">
                              <fieldset aria-hidden="true">
                                <legend style={{ width: "0px" }}>
                                  <span className="notranslate">​</span>
                                </legend>
                              </fieldset>
                              <div className="v-text-field__slot">
                                <input
                                  type="password"
                                  placeholder="Enter PIN"
                                  {...register2("verificationCode", {
                                    required: "Please enter PIN",
                                  })}
                                />
                              </div>
                            </div>
                            {errors2.verificationCode?.message && (
                              <div className="v-text-field__details">
                                <div
                                  className="v-messages theme--light error--text"
                                  role="alert"
                                >
                                  <div className="v-messages__wrapper">
                                    <div className="v-messages__message">
                                      {errors2.verificationCode.message}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row d-flex justify-center align-center no-gutters pt-4">
                    <button
                      type="submit"
                      disabled={isLoader}
                      className={`pa-2 otpSubmitButton v-btn ${
                        isLoader ? "v-btn--disabled" : ""
                      } v-btn--has-bg  v-size--default buttonPrimary theme-button  subtitle-1`}
                    >
                      <span className="v-btn__content">Submit</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default Withdraw;
